import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const DailyAttendanceRedux = createActions({
  DailyAttendanceExcelRequest: [''],
  DailyAttendanceExcelSuccess: [''],
  DailyAttendanceExcelError: ['error'],
},
{
  prefix: 'DAILY_ATTENDANCE_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = DailyAttendanceRedux
export const DailyAttendanceTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const DailyAttendanceExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const DailyAttendanceExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const DailyAttendanceExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.DailyAttendanceExcelRequest]: DailyAttendanceExcelRequest,
  [Types.DailyAttendanceExcelSuccess]: DailyAttendanceExcelSuccess,
  [Types.DailyAttendanceExcelError]: DailyAttendanceExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/DailyAttendanceRedux.js